import lodash from 'lodash';
const { unset } = lodash;

export default {
    verb: 'willChange',
    namespace: 'deviceManagement',
    relation: 'device',
    description: 'Unset location:location if location:building is changed',
    logic: willChange
};
/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function willChange({ data }) {
    if (data.foreignNamespace !== 'location') {
        return data;
    }
    if (!['company', 'building'].includes(data.foreignRelation)) {
        return data;
    }
    if (!Array.isArray(data.newRecord?.antennaConfiguration)) {
        return data;
    }
    data.newRecord.antennaConfiguration.forEach(antenna => {
        unset(antenna, 'location:location');
    });
    return { ...data, newRecord: { ...data.newRecord } };
}
